
import { defineComponent,onMounted,reactive,ref,toRefs,getCurrentInstance, watch, nextTick} from 'vue'
export default defineComponent({
  name: 'App',
  setup() {
    const {proxy,appContext} = getCurrentInstance() as any;
    const Cookies = appContext.app.config.globalProperties.Cookies
    onMounted(()=>{
      const url = window.location.href
      if(url.indexOf('utm_source') !== -1) {
        const reg = new RegExp("(^|&)" + 'utm_source' + "=([^&]*)(&|$)")
        const r = url.substr(url.indexOf('?') + 1).match(reg)
        if (r != null) {
            Cookies.set("utm_source", r[2], { expires: 7 })
        }
      }
      if(url.indexOf('utm_campaign') !== -1) {
        const reg = new RegExp("(^|&)" + 'utm_campaign' + "=([^&]*)(&|$)")
        const r = url.substr(url.indexOf('?') + 1).match(reg)
        if (r != null) {
          Cookies.set("utm_campaign", r[2], { expires: 7 })
        }
      }
    })
  }
})
